import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {DrawerGapFromTopComponent} from '../drawer-gap-from-top/drawer-gap-from-top.component';

import {PillComponent} from '../pill/pill.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SpinnerComponent} from '../spinner/spinner.component';
import {TilesService} from '../../../core/services/tiles.service';
import {from, mergeMap, toArray} from 'rxjs';
import {TileIconComponent} from '../tile-icon/tile-icon.component';
import {Tile, TILE_TYPE_SUPER_FOLDER} from '../../../shared/models/tile';
import {TileWithChildren} from '../../../shared/models/tile-with-children';

@Component({
    selector: 'motn-app-bulk-editor',
    templateUrl: './app-bulk-editor.component.html',
    styleUrls: ['./app-bulk-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    DrawerGapFromTopComponent,
    PillComponent,
    ReactiveFormsModule,
    FormsModule,
    SpinnerComponent,
    TileIconComponent
]
})
export class AppBulkEditorComponent {
  @Output() closed$: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() tiles: TileWithChildren[] = [];
  savingInProcess = false;


  constructor(private tilesService: TilesService) {
  }


  save() {
    this.savingInProcess = true;

    let tilesToSave = [];
    this.tiles.forEach(tile => {
      tilesToSave = [...tilesToSave, tile];
      if (tile.Type === TILE_TYPE_SUPER_FOLDER) {
        tilesToSave = [...tilesToSave, ...tile.children];
      }
    });

    from(tilesToSave).pipe(
      mergeMap(tile => this.tilesService.saveTile$(tile), 10), // Limit concurrency to 10 to not overload the server
      toArray(),
    ).subscribe({
      next: () => {
        this.closed$.emit(true);
      },
      error: error => {
        console.error('An error occurred:', error);
      },
      complete: () => this.savingInProcess = false,
    });
  }


  get hasTiles(): boolean {
    return Boolean(this.tiles.length);
  }

  getFacetText(tile: Tile): string {
    return tile.facets.map(f => f.Value).join(' · ');
  }
}
